import Vue from "vue";
import httpManager from '../../util/common'
import {reportYear,entityOaid} from '../../util/util'
const report_year_list=reportYear.esg_report_years
let vm = {
  delimiters: ['{', '}'],
  props: {

  },
  data: () => {
    return {
      oaid: null,
      industry: "",
      officialName: "",
      report_date: [],
    }
  },
  methods: {
    callIndicationTable(){
      let id = this.$route.params.oaid
      let self = this
      reportYear.esg_report_month().then(result => {
        self.report_date = result.report_annual_list
        entityOaid.oaid(id).then(result => {
          self.oaid =result
        })
      })
    }
  },
  mounted () {
    this.callIndicationTable()
  }
}
Vue.component("esg-entity-indicator-annual", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_entity_indicator_annual.js